export function fuzzyStringToNum(value) {
    let numVal;
    if (typeof value === "string") {
        const cleanValue = value.trim();
        // Handle different number formats
        if (cleanValue.includes(",") && cleanValue.includes(".")) {
            // Check if it's European format (1.234,56) or American format (1,234.56)
            const lastCommaIndex = cleanValue.lastIndexOf(",");
            const lastDotIndex = cleanValue.lastIndexOf(".");
            if (lastCommaIndex > lastDotIndex) {
                // European format: 1.234,56 -> remove dots, replace comma with dot
                numVal = Number(cleanValue.replaceAll(".", "").replace(",", "."));
            }
            else {
                // American format: 1,234.56 -> remove commas
                numVal = Number(cleanValue.replaceAll(",", ""));
            }
        }
        else if (cleanValue.includes(",")) {
            // Only comma - could be thousands separator or decimal separator
            const commaIndex = cleanValue.indexOf(",");
            const afterComma = cleanValue.substring(commaIndex + 1);
            if (afterComma.length <= 2 && !afterComma.includes(",")) {
                // Likely decimal separator: 123,45
                numVal = Number(cleanValue.replace(",", "."));
            }
            else {
                // Likely thousands separator: 1,234
                numVal = Number(cleanValue.replaceAll(",", ""));
            }
        }
        else if (cleanValue.includes(".")) {
            // Only dot - could be thousands separator or decimal separator
            const dotIndex = cleanValue.lastIndexOf(".");
            const afterDot = cleanValue.substring(dotIndex + 1);
            if (afterDot.length <= 2) {
                // Likely decimal separator: 123.45
                numVal = Number(cleanValue);
            }
            else {
                // Likely thousands separator: 1.234
                numVal = Number(cleanValue.replaceAll(".", ""));
            }
        }
        else {
            // No separators
            numVal = Number(cleanValue);
        }
    }
    else if (typeof value === "number") {
        numVal = value;
    }
    else if (value === undefined || value === null) {
        numVal = undefined;
    }
    else {
        throw new Error(`Invalid value: ${value}`);
    }
    if (!Number.isFinite(numVal)) {
        numVal = undefined;
    }
    return numVal;
}
function numberToHdnNum(value, opts) {
    return value?.toLocaleString("en-US", opts);
}
export function fuzzyStringToHdnNum(value, opts) {
    return numberToHdnNum(fuzzyStringToNum(value), {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false,
        ...opts,
    });
}
export function fuzzyStringToHdnNumWhole(value, opts) {
    return numberToHdnNum(fuzzyStringToNum(value), {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: false,
        ...opts,
    });
}
